import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';
import { ThankYouViewDecorator } from 'site-modules/shared/components/lead-form/unified-lead-form/views/thank-you-view-decorator';

export const TransparentPricingPriceCheckerThankYouViewAsync = ThankYouViewDecorator(
  lazyLoad({
    loader: () =>
      import(
        /* webpackChunkName: "transparent-pricing-price-checker-thank-you-view" */ './transparent-pricing-price-checker-thank-you-view'
      ),
    componentName: 'TransparentPricingPriceCheckerThankYouView',
  })
);
